// extracted by css-extract-rspack-plugin
export default {"metadata":"xl4ryOrph181tnET"};